import { makeVar } from '@apollo/client';
import { checkoutMethodOptions } from '@constants/checkoutMethodOptions';

export const checkoutVar = makeVar({
  checkoutMethod: checkoutMethodOptions.PICKUP,
  address: {
    name: '',
    address: '',
    city: '',
    state: '',
    zip: '',
  },
  date: null,
  time: '',
});

export default {
  checkout: {
    read() {
      return checkoutVar();
    },
  },
};
